import { TFunction } from "i18next";
import type { ExemptableLearningObject } from "../../queries/externalTrainingSkillbook";
import type { ExemptedCourse, ExemptedCourseType } from "../../types";

export const EXEMPTED_COURSE_TYPES: readonly ExemptedCourseType[] = ["COURSE", "PATH", "ACTIVITY"];

export function getExemptedCourseTypeLabel (type: ExemptedCourseType | undefined, t: TFunction): string {
  switch (type) {
  case "COURSE":
    return t("course");
  case "PATH":
    return t("package");
  case "ACTIVITY":
    return t("learning_activity");
  default:
    return "";
  }
}

export function getExemptedCourseType (type: string | undefined): ExemptedCourseType | undefined {
  const normalized = type?.toUpperCase();
  if (normalized === "COURSE" || normalized === "PATH") return normalized;
  if (normalized?.startsWith("DA_")) return "ACTIVITY";
  return undefined;
}

export function toExemptedCourse (item: ExemptableLearningObject): ExemptedCourse {
  return {
    id: Number(item.learningObjectId),
    title: item.title ?? "",
    type: getExemptedCourseType(item.type)
  };
}

export function filterSelectableCourses (
  items: ExemptableLearningObject[],
  typeFilters: ExemptedCourseType[],
  searchText = ""
): ExemptedCourse[] {
  const search = searchText.trim().toLowerCase();
  return items
    .map(toExemptedCourse)
    .filter((course) => !search || course.title.toLowerCase().includes(search))
    .filter((course) => typeFilters.length === 0 || (!!course.type && typeFilters.includes(course.type)));
}
